import { API_URL } from 'core/infra/environment'
import { HttpClient } from 'core/infra/http/HttpClient'

import sentry from 'legacy/utils/sentry'

import { ProposalRepository } from '../infra/ProposalRepository'

export type SubmitProposalFactoryDependencies = {
  proposalRepository: ProposalRepository
}

export function submitProposalFactory({ proposalRepository }: SubmitProposalFactoryDependencies) {
  return async function submit(id: string, config?: { signal: AbortSignal }) {
    try {
      const submitMethod = proposalRepository.submitProposalV2(id, config)

      return await submitMethod
    } catch (error) {
      sentry.log(error)
      throw new Error('Could not submit the proposal', { cause: error as Error })
    }
  }
}

export async function submitProposal(id: string, config?: { signal: AbortSignal }) {
  const httpClient = new HttpClient(API_URL)
  const proposalRepository = new ProposalRepository({ httpClient })
  const submit = submitProposalFactory({ proposalRepository })

  return submit(id, config)
}
